import Header from "components/Headers/Header";
import UsersTable from "components/users/table";
import { useGetUsers } from "lib/api-users";
import React from "react";
import { Container } from "reactstrap";

const Users = () => {
  const { data: usersResponse } = useGetUsers();

  console.log(usersResponse, "usersResponse");

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <UsersTable usersData={usersResponse} isLoading={false} />
      </Container>
    </>
  );
};

export default Users;
